/**
 * GraphQL Query
 * ダッシュボード画面
 */

/**
 * お知らせ一覧
 */
export const GRAPH_QL_QUERY_NOTICE_LIST = `
  query {
    notices (?) {
      edges {
        node {
          uuid
          type
          tag
          category
          message
          link
          linkText
          createdAt
        }
      }
      totalCount
    }
  }
`

/**
 * 注文サマリ一覧
 */
export const GRAPH_QL_QUERY_SHIPMENT_SUMMARY = `
  query {
    shipmentSummarys {
      edges {
        node {
          totalCount,
          unallocated,
          pending,
          preExport,
          exported,
          canceled,
          preReExport,
          receivedShipped
        }
      }
      totalCount
    }
  }
`
/**
 * 注文サマリ一覧
 */
export const GRAPH_QL_QUERY_EXPORT_SUMMARY = `
  query {
    exportSummarys {
      edges {
        node {
          totalCount,
          notCreate,
          notSend
        }
      }
      totalCount
    }
  }
`
/**
 * 注文サマリ一覧
 */
export const GRAPH_QL_QUERY_PENDING_SUMMARY = `
  query {
    pendingSummarys {
      edges {
        node {
          totalCount,
          highPrice,
          blackList,
          newCreate,
          duplication,
          credentialNG,
          expired,
          publishingNG,
          product,
          redirection,
          other1,
          other2,
          other3,
          other4
        }
      }
      totalCount
    }
  }
`
/**
 * 注文サマリ一覧
 */
export const GRAPH_QL_QUERY_SALES_SUMMARY = `
  query {
    salesSummarys {
      edges {
        node {
          date,
          orderCount,
          orderPrice,
          exportCount,
          exportPrice
        }
      }
      totalCount
    }
  }
`
